import '@babel/polyfill'
import 'mutationobserver-shim'
import { createApp } from 'vue'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import App from './App.vue'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router'


createApp(App).use(VueViewer).use(router).mount('#app')
